import './assets/base.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from "@sentry/vue";

import App from './App.vue'
import router from './router'

const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://aaeed4fca64a8b98d960d8a388c1d89c@o4509225965453312.ingest.de.sentry.io/4509225967353936",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
});


app.use(createPinia())
app.use(router)

app.mount('#app')
